/**
 * Parse a CSV string into headers + rows.
 * Handles: quoted fields, commas inside quotes, "" escape, CRLF, trailing empty lines.
 */
function parseRow(line) {
  const fields = []
  let i = 0
  while (i < line.length) {
    if (line[i] === '"') {
      i++ // skip opening quote
      let field = ''
      while (i < line.length) {
        if (line[i] === '"') {
          if (i + 1 < line.length && line[i + 1] === '"') {
            field += '"'
            i += 2
          } else {
            i++ // skip closing quote
            break
          }
        } else {
          field += line[i]
          i++
        }
      }
      fields.push(field)
      if (i < line.length && line[i] === ',') i++
    } else {
      const comma = line.indexOf(',', i)
      if (comma === -1) {
        fields.push(line.slice(i))
        break
      }
      fields.push(line.slice(i, comma))
      i = comma + 1
    }
  }
  // Trailing comma → trailing empty field
  if (line.length > 0 && line[line.length - 1] === ',' && !line.endsWith('",')) {
    fields.push('')
  }
  return fields
}

export function parseCsv(text) {
  if (!text || !text.trim()) throw new Error('CSV file is empty')

  const lines = text
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .split('\n')

  // Strip trailing empty lines
  while (lines.length > 0 && lines[lines.length - 1].trim() === '') lines.pop()

  if (lines.length === 0) throw new Error('CSV file contains no data')
  if (lines.length === 1) throw new Error('CSV file has headers but no data rows')

  const headers = parseRow(lines[0]).map(h => h.trim().toLowerCase())
  if (headers.length === 0 || headers.every(h => h === '')) {
    throw new Error('Could not read column headers from the first row')
  }

  const rows = []
  for (let i = 1; i < lines.length; i++) {
    if (lines[i].trim() === '') continue // skip blank lines mid-file
    const values = parseRow(lines[i])
    const row = {}
    headers.forEach((h, idx) => {
      row[h] = values[idx] !== undefined ? values[idx] : ''
    })
    rows.push(row)
  }

  if (rows.length === 0) throw new Error('CSV file has no data rows after the header')

  return { headers, rows }
}
